import { cn } from "@/utils";
import type { ComponentPropsWithoutRef } from "react";
import { canvasToolbarShellVariants } from "./canvasToolbarStyles";

export type CanvasToolbarOrientation = "horizontal" | "vertical";

interface CanvasToolbarShellProps extends ComponentPropsWithoutRef<"div"> {
  orientation?: CanvasToolbarOrientation;
}

export function CanvasToolbarShell({
  orientation = "horizontal",
  className,
  children,
  ...rest
}: CanvasToolbarShellProps) {
  return (
    <div
      role="toolbar"
      className={cn(canvasToolbarShellVariants({ orientation }), className)}
      {...rest}
    >
      {children}
    </div>
  );
}
